import { LogManager } from 'core/logging/LogManager';

import enAu from 'date-fns/locale/en-AU';
import es from 'date-fns/locale/es';
import fr from 'date-fns/locale/fr';
import lt from 'date-fns/locale/lt';
import pt from 'date-fns/locale/pt';
import vi from 'date-fns/locale/vi';
import zhCn from 'date-fns/locale/zh-CN';

const logger = LogManager.getLogger('loadDateFnsLocale', { error: { logToServer: true } });

export async function loadDateFnsLocale(localeCode: string): Promise<Locale> {
  if (localeCode.startsWith('en')) {
    return enAu;
  }
  if (localeCode.startsWith('es')) {
    return es;
  }
  if (localeCode.startsWith('fr')) {
    return fr;
  }
  if (localeCode.startsWith('lt')) {
    return lt;
  }
  if (localeCode.startsWith('pt')) {
    return pt;
  }
  if (localeCode.startsWith('vi')) {
    return vi;
  }
  if (localeCode.startsWith('zh')) {
    return zhCn;
  }
  const errorMessage = `Failed to load locale for: "${localeCode}"`;
  logger.error(errorMessage);
  throw new Error(errorMessage);
}
